import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../services/general.service';

@Component({
  selector: 'app-invoice-reception',
  templateUrl: './invoice-reception.component.html',
  styleUrls: ['./invoice-reception.component.scss']
})
export class InvoiceReceptionComponent implements OnInit {
  userId: any;
  userToken: any;
  listUsers = [];
  temp = [];
  listProfiles: any;
  load = true;

  constructor(private toastr: ToastrService, private gralService: GeneralService) {
    const b = JSON.parse(decodeURIComponent(localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352')));
    console.log(b);
    this.userId = b['id'];
    this.userToken = b['session_token'];
    gralService.changeTextHead('Recepción de facturas');
  }

  ngOnInit() {
  }

}
